import { Outlet } from "react-router-dom";
import styled from "styled-components";

import { Flex } from "@sso/ui/FlexBox";

const AuthCard = styled.div`
  display: flex;
  flex-flow: row wrap;
  max-width: 400px;
  margin: 2rem 1rem;
  border-radius: 0.5rem;
  background-color: ${p => p.theme.colors.background.paper};
  z-index: ${p => p.theme.zIndex.positiveOne};
  & > * {
    max-width: 100%;
    flex-basis: 100%;
  }
  @media (min-width: ${p => p.theme.breakpoints.sm}) {
    box-shadow: ${p => p.theme.shadows[5]};
    padding: 1rem;
  }
`;

export const AuthContent = () => {
  return (
    <Flex as="main" minHeight="100vh">
      <AuthCard>
        <Outlet />
      </AuthCard>
    </Flex>
  );
};
